<template>
    <div id="Laddress">
        <div class="laddressFirst">
            <div class="laddressFirstLeft">职业资格证书管理</div>
            <div class="laddressFirstBtn" @click="newaddss()">新增</div>
        </div>
        <div style="color:red;font-size:15px;margin-bottom:20px;display:flex;justify-content: center;">药学初级专业技术人员无需添加证书</div>
        <div>
            <Table :columns="columns1" :data="data1">
                <template slot-scope="{ row }" slot="name">
                    <strong>{{ shijiantime(row.receivingTime) }}</strong>
                </template>
                <template slot-scope="{ row }" slot="action">
                    <Button v-if="row.state == 1" type="primary" ghost size="small" @click="toLive2(row)">审核意见</Button>
                    <Button v-if="row.state != 2" style="margin-left:5px" type="primary" ghost size="small" @click="toLive(row)">编辑</Button>
                    <Button v-if="row.state != 2" style="margin-left:5px" type="primary" ghost size="small" @click="toLive1(row)">删除</Button>
                </template>
            </Table>
            <div style="display:flex;justify-content: flex-end;">
				<Page :total="total" show-total :current="curPage" :page-size="maxPage" @on-change="onChange"  />
			</div>
        </div>
        <Modal v-model="modal" title="审核意见">
            <div>{{auditOption}}</div>
        </Modal>
    </div>
</template>

<script>
    import {
        queryCertification,
        getSelectCertificate,
        getSelectMajor,
        delCertificates
    } from "../../../network/LPersonal";
    import Cookies from "js-cookie";
    export default {
        data() {
            return {
                columns1: [{
                        title: "证书编号",
                        key: "id",
                    },
                    {
                        title: "取得时间",
                        key: "receivingTime",
                        slot: 'name'
                    },
                    {
                        title: "发证机构",
                        key: "certifyingAuthority",
                    },
                    {
                        title: "证书类型",
                        key: "certificatesTypeName",
                    },
                    {
                        title: "证书级别",
                        key: "certificatesLevel",
                        render: (h,params) =>{
                            let t = null;
                            let r = params.row.certificatesLevel;
                            if(r === 1){
                                t = '初级'
                            }
                            else if(r === 2){
                                t = '中级'
                            }
                            else if(r === 3){
                                t = '高级'
                            }
                            return h('div',{},t)
                        }
                    },
                    {
                        title: "专业",
                        key: "certificatesTypeName",
                    },
                    {
                        title: "证书状态",
                        key: "state",
                        render: (h,params) =>{
                            let t = null;
                            let r = params.row.state;
                            if(r == 0){
                                t = '待审核'
                            }
                            else if(r == 1){
                                t = '审核失败'
                            }
                            else if(r == 2){
                                t = '审核成功'
                            }
                            return h('div',{},t)
                        }
                    },
                    {
                        title: "操作",
                        key: "state",
                        slot: 'action',
                        minWidth: 115,
                        align: 'center'
                    },
                ],
                data1: [],
                state: "",
                modal:false,
                auditOption:"",
                curPage: 1,
				maxPage: 10,
                total:0
            };
        },
        created() {
            this.$emit("editPage", "证书管理", "证书管理");
        },
        activated() {
            this.$emit("editPage", "证书管理", "证书管理");
        },
        mounted() {
            // this.getZS();
            // this.getZY();
            this.queryCertification();
        },
        methods: {
            // 分页器
            onChange(value){
                this.curPage = value
                this.getData()
            },
            shijiantime(times) {
                var newDate = /\d{4}-\d{1,2}-\d{1,2}/g.exec(times)
                return newDate[0];
            },
            newaddss() {
                this.$router.push("/certificate1")
            },
            handleView(name) {
                this.imgName = name;
                this.visible = true;
            },
            Get(name) {
                return Cookies.get(`admin-${name}`);
            },
            // 接口
            // getZS() {
            //   getSelectCertificate().then((res) => {
            //     console.log(res, "证书类型");
            //     let arr = res.data.data;
            //     arr.forEach((element) => {});
            //     // this.certificatesType=
            //   });
            // },
            // getZY() {
            //   getSelectMajor().then((res) => {
            //     console.log(res, "专业类别");
            //   });
            // },
            queryCertification() {
                queryCertification({
                    curPage: this.curPage,
                    maxPage: this.maxPage,
                    userId: this.Get("userId"),
                }).then((r) => {
                    console.log(r.data.data.data, "证书");
                    this.data1 = r.data.data.data;
                    this.total = r.data.data.total;
                });
            },

            toLive1(row){
                this.$Modal.confirm({
                    title: '删除证书',
                    content: '确认后将删除证书，是否确认删除',
                    onOk: () => {
                        delCertificates(row.id)
                        .then(res => {
                            console.log(res)
                            if(res.data.code == 200){
                                this.$Message.success('删除成功')
                                this.queryCertification();
                            }
                        })
                    }
                });
            },

            toLive2(row){
                this.modal =true
                this.auditOption=row.auditOption
            },
            toLive(row){
                this.$router.push({path:"/certificate1",query:{list:row,type: 1}})
            },
        },
    };
</script>

<style>
    @import url("../../../assets/css/liucss/certificate.css");

    /* 上传图片 */
    .demo-upload-list {
        display: inline-block;
        width: 60px;
        height: 60px;
        text-align: center;
        line-height: 60px;
        border: 1px solid transparent;
        border-radius: 4px;
        overflow: hidden;
        background: #fff;
        position: relative;
        box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
        margin-right: 4px;
        
    }

    .demo-upload-list img {
        width: 100%;
        height: 100%;
    }

    .demo-upload-list-cover {
        display: none;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: rgba(0, 0, 0, 0.6);
    }

    .demo-upload-list:hover .demo-upload-list-cover {
        display: block;
    }

    .demo-upload-list-cover i {
        color: #fff;
        font-size: 20px;
        cursor: pointer;
        margin: 0 2px;
    }
</style>